import React, { useEffect, useState } from 'react';
import styles from './QuizWinnerList.module.css';
import handleImageError from '../../../helper/defaultImage';
import { baseUrl } from '../../../App';
import { fetchTodyLeaderboard } from '../../../services';

const QuizWinnerList = ({ eventId }) => {
  const [winnerList, setWinnerList] = useState([]);

  useEffect(() => {
    fetchTodyLeaderboard(eventId)
    .then((res) => {
      setWinnerList(res);
    });
  }, [eventId]);

  return (<>
    {winnerList.length > 0 && <div className={styles.container}>
      <h2 className={styles.title}>বিজয়ীদের তালিকা</h2>
      <div className={styles.list}>
        {winnerList.map((player) => (
          <div key={player.User_Rank} className={styles.userRow}>
            <div className={styles.rank}>{player.User_Rank}</div>
            <img
              src={
                player.avatar_img
                  ? `${baseUrl}/media/${player.avatar_img}`
                  : require(`../../../assets/avatar/avatar${player.avatar_id || 1}.png`)
              }
              alt="Avatar"
              className={styles.userAvatar}
              onError={handleImageError}
            />
            <div className={styles.userInfo}>
              <div className={styles.userMsisdn}>
                {player.msisdn ? `0${(player.msisdn).toString().slice(0, 3)}****${(player.msisdn).toString().slice(-3)}` : ''}
              </div>
              <div className={styles.timeAndScore}>
                <span>{player.time_taken}s</span>
                <span>{player.score}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>}
    </>);
}

export default QuizWinnerList;